/* Nude Project — Creators Talent Grid.

   THIS IS THE POINT OF THE PORT. The source (live theme 189716037956, Prestige)
   ran its logic inside a `DOMContentLoaded` handler. That event fires once per
   page load, so when the theme editor swaps a section's markup on
   `shopify:section:load` the new DOM never got wired up: no video autoplay, a
   blank counter and a dead Load More until the editor was fully refreshed.

   A custom element removes the problem rather than patching it —
   connectedCallback runs every time an instance is inserted into the document,
   which is exactly what a section reload does. */
class CreatorsTalentsGrid extends HTMLElement {
  connectedCallback() {
    // connectedCallback fires on every insertion — including a move within the
    // DOM — so guard, or a second run would stack duplicate click handlers and
    // reveal two batches per click.
    if (this.initialised) return;

    this.grid = this.querySelector('[data-ct-grid]');
    if (!this.grid) return;

    this.initialised = true;

    this.perPage = parseInt(this.grid.getAttribute('data-per-page'), 10) || 30;
    this.total = parseInt(this.grid.getAttribute('data-total'), 10) || 0;
    this.counter = this.querySelector('[data-ct-counter]');
    this.button = this.querySelector('[data-ct-loadmore]');

    // Autoplay videos only while in the viewport (play on enter / pause on leave).
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const played = video.play();
            if (played && played.catch) played.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    this.observeVisibleVideos();
    this.updateCounter();

    if (this.button) {
      this.onLoadMore = this.loadMore.bind(this);
      this.button.addEventListener('click', this.onLoadMore);
    }
  }

  disconnectedCallback() {
    // Released so a section the merchant deletes in the editor does not leave an
    // observer holding on to detached <video> nodes.
    if (this.observer) this.observer.disconnect();
    if (this.button && this.onLoadMore) this.button.removeEventListener('click', this.onLoadMore);
    this.initialised = false;
  }

  observeVideos(scope) {
    scope.querySelectorAll('video.ct-media').forEach((video) => this.observer.observe(video));
  }

  observeVisibleVideos() {
    this.grid.querySelectorAll('.ct-cell:not([hidden])').forEach((cell) => this.observeVideos(cell));
  }

  shownCount() {
    return this.grid.querySelectorAll('.ct-cell:not([hidden])').length;
  }

  updateCounter() {
    if (this.counter) {
      this.counter.textContent = 'Viewing 1–' + this.shownCount() + ' out of ' + this.total;
    }
  }

  /* Load More reveals the next batch of already-rendered cells — the metafield
     list is not server-paginatable, so every cell ships with the page and the
     overflow is hidden. */
  loadMore() {
    const hiddenCells = this.grid.querySelectorAll('.ct-cell[hidden]');
    const batch = Array.prototype.slice.call(hiddenCells, 0, this.perPage);

    batch.forEach((cell) => {
      cell.removeAttribute('hidden');
      this.observeVideos(cell);
    });

    this.updateCounter();

    if (this.grid.querySelectorAll('.ct-cell[hidden]').length === 0 && this.button) {
      this.button.remove();
      this.button = null;
    }
  }
}

if (!customElements.get('creators-talents-grid')) {
  customElements.define('creators-talents-grid', CreatorsTalentsGrid);
}
